// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-qLI6E","iconWrap":"iconWrap-7wz02","lang":"lang-AmUnV","item":"item-EvB5S","menu":"menu-XCep3","option":"option-xx6oI"};